import { __generator } from "tslib";
import { put, call, takeEvery } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { showCopyingDone } from '../actionCreators';
import * as actionTypes from '../constants/actionTypes';
export default function showCopying() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(actionTypes.SHOW_COPYING, function (_a) {
                    var target = _a.target;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, call(delay, 500)];
                            case 1:
                                _b.sent();
                                return [4 /*yield*/, put(showCopyingDone(target))];
                            case 2:
                                _b.sent();
                                return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
